import React, {Component} from 'react';
import {connect} from 'react-redux';
import {isNumber, isNaN} from 'lodash';
import {Table, Icon} from 'semantic-ui-react';
import {reduxForm, Field, FieldArray} from 'redux-form';
import {tabKeyCode, enterKeyCode} from '../../../common/constants/keyCodes';
import {stockAdjustmentStates} from '../../../common/dictionaries/parameters';
import {getNumericValue} from '../../../common/util/fieldsValidation';
import {STOCK_ADJUSTMENT_FORM} from '../../../common/forms';
import {InputField} from '../../../common/components/form';
import {stopEvent} from '../../../common/util/event';
import {Actions} from '../../../common/actions';
import DeleteModal from './deleteModal';

const evaluateItem = (value) => {
  if (isNumber(value) && !isNaN(value)) {
    return value;
  }
  return 0;
};

const sumQuantity = (arr) => arr.reduce((acc, item) => acc + evaluateItem(item.quantity), 0);
const sumQuantityPrice = (arr) => arr.reduce((acc, item) => acc + evaluateItem(item.cost * item.quantity), 0);
const sumTotalItems = (arr) => arr.reduce((acc, item) =>
  acc + (isNumber(item.quantity) && !isNaN(item.quantity) ? 1 : 0), 0);

class StockAdjustmentDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {'updatedPartInfo': false};
    this.renderTable = this.renderTable.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
    const {currentIndex, loading} = this.props;
    if (prevProps.loading === true && loading === false && currentIndex !== null) {
      this.setState({'updatedPartInfo': true}, () => {
        setTimeout(() => this.focusQuantityField(currentIndex), 100);
      });
    }
  }

  focusQuantityField(index) {
    const element = document.getElementsByName(`detail[${index}].quantity`)[0];
    element.focus();
  }

  addNewItem(fields) {
    this.setState({'updatedPartInfo': false}, () => fields.push({}));
  }

  removeItem(fields, index) {
    this.setState({'updatedPartInfo': false}, () => fields.remove(index));
  }

  deleteItem(index, itemData) {
    const {code} = this.props;
    this.props.removeAdjustmentItem(code, index, itemData);
  }

  onQuantityKeyDown(index, row, event) {
    const {code, jdeType, adjustmentType} = this.props;
    const value = event.target.value;
    if (!(event.keyCode === tabKeyCode || event.keyCode === enterKeyCode)) {
      return;
    }

    stopEvent(event);
    if (!value || !row.partCode) {
      this.props.addMessageBoxError('El código del repuesto y la cantidad son obligatorios');
      return;
    }

    if (adjustmentType === '-' && (value <= 0 || value > row.availableStock)) {
      this.props.addMessageBoxError(`El campo cantidad debe estar entre 1 y ${row.availableStock}`);
      return;
    }
    this.props.addAdjustmentItem(code, index, {...row, jdeType, 'quantity': value});
  }

  onPartCodeKeyDown(index, event) {
    const {warehouse} = this.props;
    if (!(event.keyCode === tabKeyCode || event.keyCode === enterKeyCode)) {
      return;
    }

    stopEvent(event);
    if (event.target.value) {
      this.setState({'currentIndex': index});
      this.props.verifyStockInWarehouse(warehouse, event.target.value, index);
    }
  }

  renderTotalRow(fields) {
    const {action} = this.props;
    const allFields = fields.getAll() || [];
    return (
      <Table.Row>
        <Table.Cell className='part-code bold' textAlign='center' width={2}>
        Total {sumTotalItems(allFields)}
        </Table.Cell>
        <Table.Cell className='part-code' textAlign='center' width={2}/>
        <Table.Cell className='part-code bold' textAlign='center' width={2}>
          {sumQuantity(allFields)}
        </Table.Cell>
        <Table.Cell className='part-code' textAlign='center' width={2}/>
        <Table.Cell className='part-code' textAlign='center' width={2}/>
        <Table.Cell className='part-code bold' textAlign='center' width={2}>
          $ {sumQuantityPrice(allFields).toFixed(2)}
        </Table.Cell>
        {action !== 'ver' && action !== 'aprobar' && <Table.Cell className='part-code' textAlign='center' width={2}/>}
      </Table.Row>
    );
  }

  renderPartCode(index, item, row) {
    if (!row.lineNumber) {
      return (<Field
        name={`${item}.partCode`}
        component={InputField}
        onKeyDown={(event) => this.onPartCodeKeyDown(index, event)}
        autoFocus
        required
      />);
    }
    return row.partCode;
  }

  renderPartQuantity(index, item, row) {
    if (!row.lineNumber) {
      return (<Field
        name={`${item}.quantity`}
        component={InputField}
        onKeyDown={(event) => this.onQuantityKeyDown(index, row, event)}
        disabled={!this.state.updatedPartInfo}
        type='number'
        required
      />);
    }
    return row.quantity;
  }

  renderTotalPrice(row) {
    const {quantity, cost} = row;

    if (quantity && cost) {
      const total = parseInt(quantity, 10) * cost;
      return getNumericValue(total, 2);
    }
    return 0;
  }

  renderItemActions(fields, index, row) {
    if (row.lineNumber) {
      return (
        <DeleteModal
          title='eliminar el item'
          deleteFunction={() => this.deleteItem(index, row)}
          trigger={<Icon name='trash' size='big' link />}
        />
      );
    }
    return (<Icon name='close' size='big' color='red' link onClick={() => this.removeItem(fields, index)} />);
  }

  renderActions(fields, index, row) {
    const {state, action} = this.props;
    if ((action === 'nuevo' || action === 'editar') && state === stockAdjustmentStates.enter) {
      return (
        <Table.Cell textAlign='center' width={2}>
          {this.renderItemActions(fields, index, row)}
        </Table.Cell>
      );
    }
  }

  renderRow(fields, item, index) {
    const row = fields.get(index);
    return (
      <Table.Row key={index}>
        <Table.Cell className='part-code' textAlign='center' width={2}>
          {this.renderPartCode(index, item, row)}
        </Table.Cell>
        <Table.Cell textAlign='center' width={4}>
          {row.partName}
        </Table.Cell>
        <Table.Cell className='part-quantity' textAlign='center' width={2}>
          {this.renderPartQuantity(index, item, row)}
        </Table.Cell>
        <Table.Cell textAlign='center' width={2}>
          {row.availableStock}
        </Table.Cell>
        <Table.Cell textAlign='center' width={2}>
          {'$'}{getNumericValue(row.cost, 2)}
        </Table.Cell>
        <Table.Cell textAlign='center' width={2}>
          {'$'}{this.renderTotalPrice(row)}
        </Table.Cell>
        {this.renderActions(fields, index, row)}
      </Table.Row>
    );
  }

  renderFooter(fields) {
    const {state, action} = this.props;
    if (
      (action === 'nuevo' || action === 'editar') &&
      state === stockAdjustmentStates.enter
    ) {
      return (
        <Table.Footer>
          <Table.Row>
            <Table.HeaderCell colSpan={7} textAlign='left'>
              <a
                className='add-element'
                onClick={() => this.addNewItem(fields)}
              >
                <strong>
                  <Icon name='add' size='large' />
                  AGREGAR REGISTRO
                </strong>
              </a>
            </Table.HeaderCell>
          </Table.Row>
        </Table.Footer>
      );
    }
  }

  renderItems(fields) {
    return (
      <Table.Body>
        {fields.map((item, index) => this.renderRow(fields, item, index))}
        {this.renderTotalRow(fields)}
      </Table.Body>
    );
  }

  renderActionsColumn() {
    const {state, action} = this.props;
    if ((action === 'nuevo' || action === 'editar') && state === stockAdjustmentStates.enter) {
      return (<Table.HeaderCell textAlign='center'>Acciones</Table.HeaderCell>);
    }
  }

  renderTable({fields}) {
    return (
      <Table striped>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell textAlign='center'>Código Parte</Table.HeaderCell>
            <Table.HeaderCell textAlign='center'>Descripción</Table.HeaderCell>
            <Table.HeaderCell textAlign='center'>Cantidad</Table.HeaderCell>
            <Table.HeaderCell textAlign='center'>
              Cantidad Disponible
            </Table.HeaderCell>
            <Table.HeaderCell textAlign='center'>
              Costo Unitario
            </Table.HeaderCell>
            <Table.HeaderCell textAlign='center'>Costo Total</Table.HeaderCell>
            {this.renderActionsColumn()}
          </Table.Row>
        </Table.Header>
        {this.renderItems(fields)}
        {this.renderFooter(fields)}
      </Table>
    );
  }

  render() {
    return (<FieldArray name="detail" component={this.renderTable} />);
  }
}

export {StockAdjustmentDetail};

const form = reduxForm({
  'form': STOCK_ADJUSTMENT_FORM.name,
})(StockAdjustmentDetail);

const mapStateToProps = (state) => {
  const {values, currentIndex, loading} = state.form.stockAdjustment;
  const {code, warehouse, adjustmentType, jdeType} = values || {};

  return {
    code,
    warehouse,
    adjustmentType,
    jdeType,
    'state': values.state,
    loading,
    currentIndex,
  };
};

const {
  addAdjustmentItem,
  removeAdjustmentItem,
  addMessageBoxError,
  verifyStockInWarehouse,
} = Actions;

export default connect(mapStateToProps, {
  addAdjustmentItem,
  removeAdjustmentItem,
  addMessageBoxError,
  verifyStockInWarehouse,
})(form);
